// extracted by mini-css-extract-plugin
export default {"rating":"Oz-z","numberOfStars":"Pz-z","count":"Qz-z","barGraphSpacing":"Rz-z","barGraph":"Sz-z"};